import React from 'react';
import styled from 'styled-components';
import { media } from '../common-data';
import { pxToRem } from '../utils/ConvertUtils';
import i18n from '../i18n/i18n';

interface BTTextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

export const BTTextArea = styled.textarea.attrs<BTTextAreaProps>(props => ({
  placeholder: props.placeholder || '',
  maxLength: props.maxLength,
}))<BTTextAreaProps>`
  width: 100%;
  min-height: 473px;
  padding: ${pxToRem(33)} ${pxToRem(22)};
  font-size: ${pxToRem(26)};
  font-weight: 400;
  line-height: 1.5;
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};
  background-color: #fff;
  color: #444;
  caret-color: #444;
  color-scheme: light;

  border: 1px solid #B2B2B2;
  border-radius: 8px;
  resize: none;
  overflow-y: auto;

  box-sizing: border-box;
  outline: none;

  &:focus {
    border-color: #888;
  }

  &::placeholder {
    color: #979797;
  }

  ${media.mobile`
    font-size: 12px;
    line-height: 32px;
    padding: 12px 12px;
  `}
`;
